<template>
  <div>
    <template v-for="(item, itemIndex) in arrayList">
      <div v-show="selectedValue == item || selectedValue == 'All'" :key="itemIndex" class="u-mrgn-top--6">
        <div v-if="filter">
          <a
            v-if="filterMode === 'product'"
            :href="getTypeUrl(item)"
            data-no-turbolink="true"
            class="u-txt--fair u-txt--bold u-fg--black qa-product-list__title"
            >{{ item }}
          </a>
          <span v-else class="u-txt--fair u-txt--bold u-fg--black qa-product-list__title">{{ item }}</span>
        </div>
        <div v-for="(product, productIndex) in filteredProduct(item)" :key="product.id">
          <ProductItem :product="product" :index="productIndex" :from-seo-content="fromSeoContent" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { generateSeoTypeUrl } from 'shared/helpers/seoMap';
import ProductItem from './ProductItem';

export default {
  name: 'ProductListItem',
  components: {
    ProductItem,
  },
  props: {
    arrayList: {
      type: Array,
      default: () => [],
    },
    selectedValue: {
      type: String,
      default: 'All',
    },
    products: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Boolean,
      default: false,
    },
    filterMode: {
      type: String,
      default: 'product',
    },
    fromSeoContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attr() {
      return this.filterMode === 'product' ? 'type' : 'custodian_bank_name';
    },
  },
  methods: {
    getTypeUrl(type) {
      return generateSeoTypeUrl(type);
    },
    filteredProduct(item) {
      return this.products.filter(product => product[this.attr] === item);
    },
  },
};
</script>
